export default function(data) {
  var self = this;
  self.badges = ko.observableArray([]);

  self.bindData = function() {
    var mapped = ko.mapping.fromJS(data);
    self.badges(mapped());
  };

  const __construct = function(that) {
    that.bindData(data);
  }(this);
}
